import { useQuery } from 'react-query'
import { api } from '../../../utils/api'

const PAYMENT = 'internal/payments'
const TOTAL_ACCUMULATE = `${PAYMENT}/total-accumulate`

export const useGetTotalAccumulate = (isEnabled?: boolean) => {
  return useQuery(
    [],
    async () => {
      const { data } = await api.savvyGold.get<number>(TOTAL_ACCUMULATE)
      const result = data.data

      return result
    },
    {
      keepPreviousData: true,
      refetchInterval: 5 * 1000,
      enabled: isEnabled,
    },
  )
}
